import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router'
import { ThemeProvider, ToastContainer } from '@rr/ui'

import { ReactQueryProvider } from '@/components/providers/ReactQueryProvider'
import { router } from './router'
import '@/app/globals.css'

const container = document.getElementById('root')
if (!container) throw new Error('Root container #root not found')

createRoot(container).render(
  <StrictMode>
    <ThemeProvider>
      <ReactQueryProvider>
        <RouterProvider router={router} />
        <ToastContainer />
      </ReactQueryProvider>
    </ThemeProvider>
  </StrictMode>,
)
